import { handleDataInvoice } from '@/utils/invoice';
import BaseProxy from '../base-proxy';
import Vue from 'vue';

/**
 * Class PublishedInvoiceProxy
 */
class PublishedInvoiceProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/e-invoice-api/api/invoices/published', parameters);
    this.defaultOptions = { allowToast: false };
  }

  transferInvoiceForToken(payload, options = {}) {
    return this.submit('post', `${this.endpoint}/transfer-invoice-for-token/${payload.id}`, payload.data, { ...this.defaultOptions, ...options });
  }

  prepareTransferInvoiceForToken(id, options = {}) {
    return this.submit('post', `${this.endpoint}/prepare-transfer-invoice-for-token/${id}`, null, { ...this.defaultOptions, ...options });
  }

  getTransferPublishedInvoice(id, options = {}) {
    return this.submit('get', `${this.endpoint}/transfer_invoice/${id}`, null, { ...this.defaultOptions, ...options });
  }

  replacedPublishedInvoice(payload, options = {}) {
    const data = handleDataInvoice(payload);
    return this.submit('post', `${this.endpoint}/replaced/${data.id}`, data, { ...this.defaultOptions, ...options });
  }

  evidenceForChangePublishedInvoice(payload, options = {}, uploadStatus = {}) {
    const { id, dataFile } = payload;
    return this.submit('post', `${this.endpoint}/evdence_for_change/${id}`, dataFile, {
      ...this.defaultOptions,
      ...options,
      onUploadProgress(progressEvent) {
        uploadStatus.percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  editPublishedInvoice(payload, options = {}) {
    const data = handleDataInvoice(payload);
    return this.submit('post', `${this.endpoint}/edit/${data.id}`, data, { ...this.defaultOptions, ...options });
  }

  editProductPublishedInvoice(payload, options = {}) {
    const data = handleDataInvoice(payload);
    return this.submit('post', `${this.endpoint}/edit_product/${data.id}`, data, { ...this.defaultOptions, ...options });
  }

  cancelPublishedInvoice(payload, options = {}) {
    const { id, ...data } = payload;
    return this.submit('post', `${this.endpoint}/cancel/${id}`, data, { ...this.defaultOptions, ...options });
  }

  sendMailPublishedInvoice(payload, options = {}) {
    const { id, ...data } = payload;
    return this.submit('post', `${this.endpoint}/send-email/${id}`, data, { ...this.defaultOptions, ...options });
  }

  statisticMistakeInvoice(options = {}) {
    // const fetchResp = this.submit('get', `${this.endpoint}/statistic-mistake-invoice`, null, { ...this.defaultOptions, ...options });
    const promise = new Promise((resolve, reject) => {
      Vue.$http.get(`${this.endpoint}/statistic-mistake-invoice` + this.getParameterString(), { ...this.defaultOptions, ...options })
      .then(response => this.onSubmitSuccess(response, resolve, options))
      .catch(({ response }) => this.onSubmitError(response, reject, options));
    })

    if (options.showLoading) {
      const msg = options.loadingMessage || Vue.i18n.t('app.processing');
      this.handleLoadingToast(promise, ToastUtils.showToast('loading', msg));
    }

    this.afterSubmitHandler(promise, options);
    return promise;
  }

  sendStatisticMistakeInvoice(payload, uploadStatus) {
    const formData = new FormData();

    formData.append('uu_id', payload.id);
    formData.append('xml_file', payload.xml);
    formData.append('pdf_file', payload.pdf);

    return this.submit('post', `${this.endpoint}/send-statistic-mistake-invoice`, formData, {
      ...this.defaultOptions,
      onUploadProgress(progressEvent) {
        uploadStatus.percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        );
      },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default PublishedInvoiceProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice/published-invoice-proxy.js